module.exports = __webpack_public_path__ + "static/media/edit-icon.84964a60.svg";